import styled from 'styled-components/macro'

const SearchResultListing = styled.ul`
  font-family: 'Open Sans', sans-serif;
  list-style-type: none;
  padding-left: 0;
  margin-left: -10px;
  margin-right: -10px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`

export default SearchResultListing
